import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect, useState, useRef } from 'preact/hooks'

import NoResults from './NoResults'
import Products from './Products'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import BottomToolbar from './BottomToolbar'
import Loader from './Loader'

export default () => {
    const { response, loading, } = useAppState();
    const [ sidebarActive, setSidebarActive ] = useState(false);
    const foundProducts = response.products && response.products.total > 0
    const serpRef = useRef(null);

    useEffect(() => {
        if(!serpRef.current) return;
        if (sidebarActive && window.innerWidth < 1024) {
            document.querySelector('body').style.overflow = 'hidden'
            serpRef.current.style.zIndex = '10'
        } else {
            document.querySelector('body').style.overflow = 'initial'
            serpRef.current.style.zIndex = 'unset'
        }
    }, [ sidebarActive ])

    const toggleSidebar = () => {
        setSidebarActive(!sidebarActive);
    }

    return (
        <div class="ns-serp ns-font-inherit" data-nosto-element="search" ref={serpRef}>
            {loading && !foundProducts ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Toolbar 
                        toggleSidebar={toggleSidebar} 
                    />
                    <div class="ns-body-container flex flex-col" style={loading ? 'position: relative;' : ''} >
                        <Sidebar 
                            sidebarActive={sidebarActive} 
                            toggleSidebar={toggleSidebar} 
                        />
                        <Products 
                            sidebarActive={sidebarActive} 
                        />
                    </div>
                    <BottomToolbar/>
                </>
            ) : (
                <NoResults/>
            )}
        </div>
    )
}